export const updateTopic = (topic) => ({
  type: 'UPDATE_TOPIC',
  topic
});
